import { defineComponent as _defineComponent } from 'vue'
import SpinnerDots from '@/features/ui/components/SpinnerDots.vue';

import { ArticleClickedData } from '@/features/editorial/types/editorial-types';

import { useGuideModules } from '@/features/editorial/composables/useGuideModules';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuideModuleLoader',
  emits: ["articleClicked", "authorClicked"],
  setup(__props, { emit: emits }: { emit: ({
	(e: 'articleClicked', data?: ArticleClickedData): void;
	(e: 'authorClicked', id: string | undefined): void;
}), expose: any, slots: any, attrs: any }) {

const { modules, loading, getLayoutComponent } = useGuideModules();



function handleArticleClick(data?: ArticleClickedData) {
	emits('articleClicked', data);
}

function handleAuthorClick(id: string | undefined) {
	emits('authorClicked', id);
}

return { __sfc: true,modules, loading, getLayoutComponent, emits, handleArticleClick, handleAuthorClick, SpinnerDots }
}

})